import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Mail, Lock, ShieldCheck, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/admin-login", form);
      login(r.data.token, r.data.user);
      toast.success("Admin sign-in successful");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Admin login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-zinc-200 bg-white p-8 space-y-6">
        <div className="flex items-center gap-3 border-b border-zinc-200 pb-4">
          <div className="w-10 h-10 bg-[#0A0A0A] text-white flex items-center justify-center">
            <ShieldCheck size={20} strokeWidth={1.5} />
          </div>
          <div>
            <div className="label-caps text-zinc-500">Restricted</div>
            <h1 className="font-display text-2xl tracking-tight">Superadmin Login</h1>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="label-caps text-zinc-500 mb-2 block">Admin Email</label>
            <div className="relative">
              <Mail size={16} strokeWidth={1.5} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-400" />
              <input
                type="email"
                className="input-flat pl-11"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder=""
                autoComplete="off"
                data-testid="admin-email-input"
              />
            </div>
          </div>
          <div>
            <label className="label-caps text-zinc-500 mb-2 block">Password</label>
            <div className="relative">
              <Lock size={16} strokeWidth={1.5} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-400" />
              <input
                type="password"
                className="input-flat pl-11"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder="••••••••"
                data-testid="admin-password-input"
              />
            </div>
          </div>
          <button type="submit" className="btn-primary-flat w-full bg-[#0A0A0A] hover:bg-zinc-800" disabled={loading} data-testid="admin-submit-btn">
            {loading ? "Signing in..." : "Sign in as Superadmin"}
            <ArrowRight size={16} strokeWidth={1.5} />
          </button>
        </form>
      </div>
    </div>
  );
}
